'use client'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import { getDoctors } from '@/utils/doctor/getDoctors'
import { useLocale } from 'next-intl'
import LoadingState from '@/components/main/element/LoadingState'
import EmptyState from '@/components/main/element/EmptyState'
import { useParams } from 'next/navigation'
import { useRouter } from '@/navigation'

const DoctorSearchPage = () => {
  const router = useRouter()
  const { hospital } = useParams()
  const searchParams = useSearchParams()
  const locale = useLocale()
  const [isFetching, setIsFetching] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  const code = searchParams.get('code')
  const searchTerm = searchParams.get('s')
  const isAppointment = searchParams.get('appointment')
  const date = searchParams.get('date')
  const isCodeNumber = /^\d+$/.test(code)

  useEffect(() => {
    const fetchDoctors = async () => {
      if (code && isCodeNumber) {
        const doctor_query = {
          meta_query: [
            {
              key: 'care_provider_code',
              value: code,
              compare: '=',
            },
          ],
          hospital_slugs: [hospital],
        }
        try {
          setIsFetching(true)
          const res = await getDoctors({ queryObj: doctor_query })

          if (res?.posts?.length > 0) {
            const doctorSlug = res.posts[0]?._slug
            const dateParam = date ? `?date=${date}` : ''
            router.push(
              `/${hospital}/doctor/${doctorSlug}${dateParam}${isAppointment ? '#appointment' : ''}`
            )
          } else {
            setIsEmpty(true)
          }
        } catch (error) {
          console.error('Error fetching doctors:', error)
        } finally {
          setIsFetching(false)
        }
      } else if (searchTerm) {
        const doctor_query = {
          s: searchTerm,
          hospital_slugs: [hospital],
        }
        try {
          setIsFetching(true)
          const res = await getDoctors({ queryObj: doctor_query })

          if (res?.posts?.length > 0) {
            router.push(`/${hospital}/doctor/${res.posts[0]?._slug}`)
          } else {
            router.push(`/${hospital}/doctor`)
          }
        } catch (error) {
          console.error('Error fetching doctors:', error)
        } finally {
          setIsFetching(false)
        }
      } else {
        setIsEmpty(true)
        console.error(
          'Neither care provider code nor search term provided in query parameters.'
        )
      }
    }

    fetchDoctors()
  }, [searchParams, router])

  if (isFetching) {
    return <LoadingState />
  }

  if (isEmpty) {
    return <EmptyState />
  }

  if (!code && !searchTerm) {
    return (
      <div className="tw-w-full tw-h-screen tw-flex tw-justify-center tw-items-center tw-text-center tw-text-2xl tw-font-bold">
        No search term provided.
      </div>
    )
  }

  return null
}

export default DoctorSearchPage
